import { createSelector } from '@reduxjs/toolkit';
import {
  checkTimeAvailability,
  calculateItemAvailabilityTime,
} from '../utils/ordering';
import { getMenu, getCategoryAvailabilityById } from './';
import getOrderDateTimeSelected from './getOrderDateTimeSelected';

/**
 * # Get Item Availability
 * This is used in each of the <MenuListItems/> on various platforms
 *
 * - If this returns:
 *  - false -> render nothing
 *  - true -> render the actual component
 *
 * ## Note:
 * If you are looking for what decides if a section of the menu
 * gets rendered based on the availability of a section look at:
 * rootSubCategoriesFilteredByAvailability in
 * getFilteredRootCategory
 *
 */
export default (item: Item, mimCategoryId?: string, dayInFull?: boolean) =>
  createSelector(
    [
      getMenu,
      getCategoryAvailabilityById(mimCategoryId || ''),
      getOrderDateTimeSelected,
    ],
    (
      menu,
      [catAvailability, catAvailibilityString],
      dateTimeSelected,
    ): [boolean, string] => {
      if (!item || !menu) return [false, ''];

      if (!catAvailability) return [false, catAvailibilityString];
      const { start, end, days, availability } = item;

      return [
        checkTimeAvailability({
          availability,
          days,
          start,
          end,
          dateTimeSelected,
        }),
        calculateItemAvailabilityTime(
          availability,
          days,
          start,
          end,
          dayInFull,
        ),
      ];
    },
  );
